import { Action } from 'redux-act';
import { ThunkAction } from 'redux-thunk';

type IAction<Val> = (val: Val) => Action<Val> | ThunkAction<any, any, any, any>;

export const serverDataDispatcher = <Req extends App.ReduxNextPageContext['req'] = App.ReduxNextPageContext['req']>(
  req: Req,
  config: { [key in keyof Req]: IAction<Req[key]> },
) => (dispatch) => {
  Object.entries<IAction<any>>(config).forEach(([key, action]) => {
    const value = req?.[key];
    if (value) {
      dispatch(action(value));
    }
  });
};
